module.exports = __webpack_public_path__ + "static/media/bg_psword.c57e7d29.svg";